var map = {
	"./1Password.png": "5a84",
	"./Blinq.png": "c571",
	"./DMZ.png": "d9dc",
	"./Innovapost.png": "687c",
	"./Neo.png": "dbb7",
	"./Newton.png": "f0ad",
	"./Nokia.png": "d926",
	"./Pantheon Prototyping.png": "29c8",
	"./Rocket Innovation Studios.png": "0912"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b556";